import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Shower = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M304 320a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm32-96a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm32 64a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-32 32a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-32-64a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm128-32a16 16 0 1 0-16-16 16 16 0 0 0 16 16zm-48 16a16 16 0 1 0 16-16 16 16 0 0 0-16 16zm-16-48a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm96 32a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm32-32a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-64 64a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-32 32a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-64 64a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm-32 32a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm64-64a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm21.65-218.35-11.3-11.31a16 16 0 0 0-22.63 0L350.05 96A111.19 111.19 0 0 0 272 64c-19.24 0-37.08 5.3-52.9 13.85l-10-10A121.72 121.72 0 0 0 123.44 32C55.49 31.5 0 92.91 0 160.85V464a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V158.4c0-30.15 21-58.2 51-61.93a58.38 58.38 0 0 1 48.93 16.67l10 10C165.3 138.92 160 156.76 160 176a111.23 111.23 0 0 0 32 78.05l-5.66 5.67a16 16 0 0 0 0 22.62l11.3 11.31a16 16 0 0 0 22.63 0l169.38-169.37a16 16 0 0 0 0-22.63z"
  }));
});
Shower.displayName = 'Shower';
export var ShowerDimensions = {
  height: 512,
  width: 512
};